import { Pipe, PipeTransform } from '@angular/core';
import { AggregationResult } from '../model/everything-search-result';
import { KeyValueCount, toKeyValueCount } from '../utils/key-value-count';

@Pipe({
  name: 'aggregationKeyValue',
  standalone: true
})
export class AggregationKeyValuePipe implements PipeTransform {

  transform(
    aggregationResults: AggregationResult[],
    valueMapper: (key: string) => string = key => key
  ): KeyValueCount[] {
    return toKeyValueCount(aggregationResults, valueMapper);
  }

}
